// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b5ba06c9","488":"0a78ae38","553":"cc8c2dec"}[chunkId] + ".chunk.js";
};